import { RESTRICTION_TYPE } from '../constants';

export default function canDeleteConversation(conversation, currentUser) {
  const isCreator = currentUser.id === conversation.created_by;

  if (conversation.private) {
    return false;
  }
  if (currentUser.isAdmin) {
    return true;
  }
  if (conversation.restricted === RESTRICTION_TYPE.NONE && (currentUser.isManager || isCreator)) {
    return true;
  }
  if (conversation.restricted === RESTRICTION_TYPE.PRIVILEGED_ONLY) {
    return currentUser.isManager;
  }
  if (
    conversation.restricted === RESTRICTION_TYPE.SELECTED_ONLY &&
    (currentUser.isManager || isCreator)
  ) {
    return conversation.restrictedToPersonas.includes(currentUser.id);
  }

  return false;
}
